<template>

  <t-dialog-form :generalErrors="generalErrors" large :title="t(command) + ' Regra'"
                 :ok-text="t(command) + ' Regra'"
                 @show="showModal" @hidden="resetModal" :busy="busy" :id="id"
                 :status="status" :command="command"
                 ref="dialog_form" @onSubmit="onSubmit">


    <t-input v-model="form.processFlowStepRuleId" hidden/>


    <b-row>
      <t-input cols="6" v-model="form.name" :add-error="error.name" label="Nome da Regra"
               required/>

      <t-input cols="6" v-model="form.groupProductId"
               :options="groupProductOptions"
               placeholder="Aplicando em Todos"
               label="Restringir grupo de produtos"
               help="Utilize se desejar restringir esta regra para algum grupo de produtos específicos."
               select/>

    </b-row>

    <b-row  v-if="form.typeAnalysis !== FlowStepRuleAnalysisType.type.TOLERANCE">


      <t-input v-model="form.typeActionRule" select-common :options="FlowStepRuleActionType.list" cols="6"
               @change="checkOptions"
               :add-error="error.typeActionRule" label="Ação"
               required/>

      <t-input select-common v-show="form.typeActionRule === 1" :required="form.typeActionRule === 1"
               v-model="form.goProcessFlowStepId" cols="6"
               :options="stepOptions"
               :add-error="error.goProcessFlowStepId" label="Etapa"
               help="Informe qual a etapa deseja que seja direcionado."/>

      <t-input select-common v-show="form.typeActionRule === 2" :required="form.typeActionRule === 2"
               v-model="form.operationStatusId" cols="6"
               :options="typeStatusProductionErrorOptions"
               :add-error="error.operationStatusId" label="Status Operacional de Erro"
               help="Informe qual o status operacional de erro será aplicado."/>


      <b-col v-show="form.typeActionRule === FlowStepRuleActionType.type.INFO" cols="12" class="mb-2">
        Texto com orientações:

        <t-editor :required="form.typeActionRule === FlowStepRuleActionType.type.INFO" small v-model="form.info"/>

      </b-col>


      <b-col v-if="form.typeActionRule === FlowStepRuleActionType.type.ALTERNATIVES" ref="container_options" cols="12"
             class="mb-2">

        <b-row class="alert-warning p-2">

          <b-col cols="12">

            <t-input
                required
                v-model="form.question"
                label="Pergunta aos operadores"
                help="Informe qual a pergunta deseja realizar aos operadores."/>


            <div v-for="(item,index) in form.alternatives" :key="item.value">

              <b-row>

                <t-input
                    class="input-type-list-option-focus"
                    cols="6"
                    :label="'Opção '+ (++index)" v-model="item.text"
                    :required="form.typeActionRule === FlowStepRuleActionType.type.ALTERNATIVES && index < 3"/>

                <t-input select
                         v-model="item.goProcessFlowStepId" cols="6"
                         :options="stepOptions"
                         label="Etapa desta alternativa"
                         help="Informe qual a etapa deseja que seja direcionado, caso esta alternativa seja escolhida."/>

              </b-row>


            </div>

            <t-button v-show="form.alternatives.length <= 20" small outline-primary icon-plus
                      @click="addAlternative" text="Adicionar alternativa"/>

          </b-col>


        </b-row>


      </b-col>


      <b-col v-show="form.typeActionRule === 3" cols="6">

        <t-input select-common :required="form.typeActionRule === 3"
                 v-model="form.operationStatusId"
                 :options="typeStatusProductionAllOptions"
                 :add-error="error.operationStatusId" label="Status Operacional"
                 help="Informe qual o status operacional deseja alterar."/>

        <b-form-checkbox v-model="form.notChangeOperationStatus" switch>
          <small>Bloquear e não permitir alterar?</small>
          <t-help
              title="Caso desejar que não seja mais alterado o status operacional, poderá deixar marcado este campo."/>
        </b-form-checkbox>

      </b-col>


    </b-row>

    <t-msg info v-else>As regras de tolerância definem limites específicos além da política geral de qualidade. Cadastre as regras de tolerância e vincule-as aos clientes para bloquear expedições de produtos fora dos limites exigidos por cada cliente.</t-msg>

    <t-input v-model="form.typeAnalysis" label="Tipo de Análise" :options="FlowStepRuleAnalysisType.list" radio
             required/>

    <b-col cols="12">

      <b-form-checkbox v-model="form.changeProductEquivalentReproved" switch>
       Substituir por produto equivante reprovado?
        <t-help title="Marque, caso desejar realizar a troca por produto equivalente reprovado. Lembre-se que é necessário cadastrar o produto equivanete no cadastro de Produtos."/>
      </b-form-checkbox>

    </b-col>



    <t-input select-common v-if="form.typeAnalysis === FlowStepRuleAnalysisType.type.OPERATION_STATUS"
             required
             v-model="form.analysisOperationStatusId"
             :options="typeStatusProductionAllOptions"
             :add-error="error.analysisOperationStatusId" label="Aplicar regra quando o Status Operacional for igual"
             help="Utilize o comparativo por status operacional, quando desejar aplicar a regra somente-se a etapa estiver com o status operacional determinado."/>

    <b-card v-else>

      <b-card-title>Critérios</b-card-title>

      <div class="table-responsive">
        <table class="mb-0 table">
          <thead>
          <tr>
            <th>Campo</th>
            <th>Condição</th>
            <th>Valor</th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="(condition) in conditions" :key="condition.processFlowStepFieldId"
              :class="{'bg-light':condition.typeCondition===ConditionType.type.NOT_USE}">
            <td class="col-4">{{ condition.name }}</td>
            <td class="col-4">
              <t-input select-common v-model="condition.typeCondition"
                       :options="getConditionTypes(condition.var,condition.type)"
              />
            </td>
            <td class="col-4">

              <div v-if="condition.typeCondition!==ConditionType.type.NOT_USE">

                <div v-if="condition.var === VarType.type.BOOLEAN">

                  <t-input cols="10" checked v-model="condition.referenceValueBoolean"/>

                </div>

                <div v-else-if="condition.var === VarType.type.INTEGER">

                  <div v-if="InputType.isList(condition.type)">

                    <t-input cols="11" hide-label label="Listagem" required
                             v-model="condition.referenceValueIntegerInitial"
                             :select-colors="condition.type === InputType.type.SELECT_COLOR" select-common
                             :options="condition.options"/>

                  </div>

                  <div v-else>

                    <div class="d-flex"
                         v-if="condition.typeCondition > 0 && typeConditionOptions.find(value => value.value === condition.typeCondition).enableFinalValue">

                      <b-col cols="6" class="mr-0 pr-0">
                        <t-input number not-row required placeholder="Inicial"
                                 label="Valor Inicial" hide-label
                                 accept-zero
                                 v-model="condition.referenceValueIntegerInitial"/>
                      </b-col>

                      <b-col cols="6" class="ml-0 pl-1 mr-0 pr-0">
                        <t-input number not-row required placeholder="Final"
                                 label="Valor Final" hide-label
                                 accept-zero
                                 v-model="condition.referenceValueIntegerFinal"/>
                      </b-col>


                    </div>

                    <div v-else>
                      <t-input cols="10" number required v-model="condition.referenceValueIntegerInitial"
                               label="Valor" hide-label/>
                    </div>

                  </div>


                </div>

                <div v-else-if="condition.var === VarType.type.DOUBLE">

                  <div class="d-flex"
                       v-if="condition.typeCondition > 0 && typeConditionOptions.find(value => value.value === condition.typeCondition).enableFinalValue">

                    <b-col cols="6" class="mr-0 pr-0">
                      <t-input not-row number required placeholder="Inicial"
                               label="Valor Inicial" hide-label
                               accept-zero
                               v-model="condition.referenceValueDoubleInitial"
                               :decimals="condition.decimalPrecision"
                      />

                    </b-col>
                    <b-col cols="6" class="ml-0 pl-1 mr-0 pr-0">
                      <t-input cols="6" not-row number required placeholder="Final"
                               label="Valor Final" hide-label
                               accept-zero
                               v-model="condition.referenceValueDoubleFinal"
                               :decimals="condition.decimalPrecision"
                      />
                    </b-col>

                  </div>

                  <div v-else>
                    <t-input cols="11" number required v-model="condition.referenceValueDoubleInitial"
                             :decimals="condition.decimalPrecision" label="Valor" hide-label
                    />
                  </div>

                </div>

                <div v-else-if="condition.var === VarType.type.DATE">

                  <div class="d-flex"
                       v-if="condition.typeCondition > 0 && typeConditionOptions.find(value => value.value === condition.typeCondition).enableFinalValue">

                    <b-col cols="6" class="mr-0 pr-0">
                      <t-input not-row required placeholder="Inicial"
                               label="Data Inicial" hide-label
                               v-model="condition.referenceValueDateInitial"
                               date date-remove-calendar
                      />
                    </b-col>
                    <b-col cols="6" class="ml-0 pl-1 mr-0 pr-0">
                      <t-input cols="6" not-row required placeholder="Final"
                               label="Data Final" hide-label
                               v-model="condition.referenceValueDateFinal"
                               date date-remove-calendar
                      />
                    </b-col>

                  </div>

                  <div v-else>

                    <t-input cols="11" required v-model="condition.referenceValueDateInitial"
                             label="Data" hide-label date date-remove-calendar
                    />
                  </div>

                </div>

                <div v-else-if="condition.var === VarType.type.STRING">

                  <!--todo deixar todos os tipos de mascaras dinamicos-->
                  <t-input cols="11" required v-model="condition.referenceValueString"
                           label="Conteúdo" placeholder="Conteúdo" hide-label
                           :cep="condition.mask === 'zipcode'"
                           :cnpj="condition.mask === 'br_cnpj'"
                           :cpf="condition.mask === 'br_cpf'"
                           :email="condition.mask === 'email'"
                           :color-reduced="condition.mask === 'color'"
                           :upper="condition.mask === 'upper'"
                           :lower-reduced="condition.mask === 'lower'"
                  />

                </div>

              </div>

              <div v-else class="text-center">

              </div>

            </td>

          </tr>

          </tbody>

        </table>

      </div>

      <t-input radio v-model="form.typeApplication" :options="typeApplicationOptions"
               :add-error="error.typeApplication" label="Tipo de Aplicação"
               required/>


    </b-card>


<b-card  class="alert-warning" v-if="form.typeAnalysis !== FlowStepRuleAnalysisType.type.TOLERANCE">

  <b-row>

    <b-col>

      <b-form-checkbox v-model="form.requiredTypeNonConformance" switch>
        <b>Exigir escolha de tipo de não conformidade geral?</b>
        <t-help
            title="Caso deixar marcado, será exibido no momento da aplicação desta regra que o operador escolha qual o tipo de não conformidade geral se aplica no caso. Caso deixar desmarcado, poderá selecionar um tipo automatico para aplicação, sem necessidade de escolha do operador."/>
      </b-form-checkbox>

      <t-input v-model="form.typeNonConformanceId" v-show="!form.requiredTypeNonConformance"
                :options="typeNonConformanceOptions"
                select
                help="Caso selecionar alguma opção e esta regra for aplicada o sistema irá aplicar este tipo de Não Conformidade automaticamente na Ordem de Fabricação."
                placeholder="Não"
                label="Aplicar não conformidade automaticamente"/>

    </b-col>




  </b-row>

</b-card>










  </t-dialog-form>


</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import http from "@/services/config/http-common";
import InputType from "@/model/types/resource/InputType";
import VarType from "@/model/types/resource/VarType";
import ConditionType from "@/model/types/resource/FieldConditionType";
import ui from "@/assets/scripts/ui";
import groupProductService from "@/services/modules/product/GroupProduct.service";
import FlowStepRuleAnalysisType from "@/model/types/modules/production/FlowStepRuleAnalysisType";
import FlowStepRuleActionType from "@/model/types/modules/production/FlowStepRuleActionType";
import tEditor from "@/components/template/page/t-editor";
import TypeNonConformanceService from "@/services/modules/production/TypeNonConformance.service";

export default {
  name: 'ProcessFlowStepRuleDialog',
  components: {tEditor, tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      InputType,
      VarType,
      ConditionType,
      FlowStepRuleAnalysisType,
      FlowStepRuleActionType,
      id: "modal-process-flow-step-rule",
      path: "production/process-flow-step-rule", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "processFlowStepRuleId",
      foreignKeyColumn: "processFlowId", //Utilizar quando usar Tabs com outros componentes
      form: {
        processFlowStepRuleId: this.processFlowStepRuleId,
        processFlowStepId: this.foreignKey,
        operationStatusId: 0,
        analysisOperationStatusId: 0,
        goProcessFlowStepId: 0,
        requiredTypeNonConformance: false,
        changeProductEquivalentReproved: false,
        typeNonConformanceId: 0,
        groupProductId: 0,
        typeAnalysis: 1,
        typeActionRule: 1,
        typeApplication: 2,
        notChangeOperationStatus: false,
        question: "",
        info: "",
        name: "",
        note: "",
        status: 1,
        conditions: [],
        alternatives: [],
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        info: "",
        operationStatusId: "",
        goProcessFlowStepId: "",
        typeActionRule: "",
        typeApplication: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      groupProductOptions: [],
      typeNonConformanceOptions: [],
      conditions: [
        /*{
          processFlowStepId: 1,
          name: "Teste 123",
          typeCondition: 99,
          var: 2,
          decimalPrecision:0,
          referenceValueBoolean: false,
          referenceValueIntegerInitial: 0,
          referenceValueIntegerFinal: 0,
          referenceValueDoubleInitial: 0.0,
          referenceValueDoubleFinal: 0.0
        },
        {
          processFlowStepId: 2,
          name: "Teste 456",
          typeCondition: 99,
          var: 2,
          decimalPrecision:0,
          referenceValueBoolean: false,
          referenceValueDoubleInitial: 0.0,
          referenceValueDoubleFinal: 0.0
        }*/],
      stepOptions: [],
      typeStatusProductionAllOptions: [],
      typeStatusProductionErrorOptions: [],
      typeApplicationOptions: [{value: 1, text: "Todos critérios atingidos"}, {
        value: 2,
        text: "Qualquer critério for atingido"
      }],
      typeConditionOptions: ConditionType.list,

    }
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {


      this.busy = true

      //Limpa os campos
      this.resetModal()


      //Limpa listagem de campos com critérios
      this.conditions = []


      //Setar alguma informações padrão por exemplo vindo de fora
      this.form.processFlowStepRuleId = this.primaryKey
      this.form.processFlowStepId = this.foreignKey
      this.form.typeAnalysis = 1
      this.form.typeActionRule = 1
      this.form.typeApplication = 1
      this.form.requiredTypeNonConformance = false
      this.form.typeNonConformanceId = 0
      this.form.status = 1

      await http.list(this.path + "/selectRelationList/?processFlowStepId=" + this.foreignKey + "&processFlowStepRuleId=" + this.form.processFlowStepRuleId).then((list) => {

        this.stepOptions = list.stepOptions
        this.typeStatusProductionAllOptions = list.typeStatusProductionAllOptions
        this.typeStatusProductionErrorOptions = list.typeStatusProductionErrorOptions
        this.conditions = list.conditions

      }).catch(error => this.responseError(error))

      await groupProductService.selectList("grouped").then((list) => {
        this.groupProductOptions = list
      }).catch(error => this.responseError(error))

      await TypeNonConformanceService.selectList().then((response) => {
        this.typeNonConformanceOptions = response
      }).catch(error => this.responseError(error))

      await this.readModal(false)


      this.busy = false

    },

    async onSubmit() {

      let qtdConditionApply = 0
      this.form.conditions = this.conditions

      this.generalErrors = []

      for (const condition of this.conditions) {

        if (condition.typeCondition !== ConditionType.type.NOT_USE) {

          const typeCondition = ConditionType.list.find(value => value.value === condition.typeCondition)

          if (typeCondition.enableFinalValue) {

            if (condition.var === this.VarType.type.INTEGER) {

              if (condition.referenceValueIntegerInitial > condition.referenceValueIntegerFinal) {
                this.generalErrors.push(condition.name + " não poderá ter valor final inferior ao inicial")
              }

            } else if (condition.var === this.VarType.type.DOUBLE) {

              if (condition.referenceValueDoubleInitial > condition.referenceValueDoubleFinal) {
                this.generalErrors.push(condition.name + " não poderá ter valor final inferior ao inicial")
              }

            }

          }

          qtdConditionApply++

        }

      }

      if (this.generalErrors.length > 0)
        return false;

      if (qtdConditionApply === 0 && this.form.typeAnalysis === FlowStepRuleAnalysisType.type.FIELD) {
        ui.msgError(this, "Informe ao menos uma condição para inserir a regra.")
      } else {
        await this.setSubmitDialogDefault()
      }

    },

    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    getConditionTypes(typeVar, typeInput) {

      if (typeVar === VarType.type.BOOLEAN) {
        return this.typeConditionOptions.filter(a => a.typeBoolean)
      } else if (typeVar === VarType.type.STRING) {
        return this.typeConditionOptions.filter(a => a.typeString)
      } else if (InputType.isList(typeInput)) {
        return this.typeConditionOptions.filter(a => a.typeList)
      } else {
        return this.typeConditionOptions
      }

    },

    checkOptions() {

      if (this.form.typeActionRule === FlowStepRuleActionType.type.ALTERNATIVES && this.form.alternatives.length === 0) {

        this.form.alternatives.push({value: 1, text: "Sim", goProcessFlowStepId: 0})
        this.form.alternatives.push({value: 2, text: "Não", goProcessFlowStepId: 0})

      }
    },

    addAlternative() {

      const length_old = (this.form.alternatives.length)
      const length = length_old + 1;
      this.form.alternatives.push({value: length, text: ""})

      setTimeout(() => {
        this.$refs.container_options.getElementsByClassName('input-type-list-option-focus')[length_old].getElementsByTagName('input')[0].focus()
      }, 100)

    },
    //--------------------------------------------------------------------------------------
  },
}
</script>
